import { useEffect } from 'react';
import useCustomHook from '@/hooks/useCustomHook';

export default function useGameButton({}) {
  const { state, actions } = useCustomHook({
    defaultState: {},
    actions: {},
  });

  useEffect(() => {}, []);

  return { state, actions };
}
